import { isAccommodationItem } from 'lib/checkout/checkoutUtils'

const getOccupantsFromCheckoutCart = (cartItems: App.Checkout.Item[]): App.Occupants | undefined => {
  if (!cartItems.length) return
  const findFirstAccommodationItem = cartItems.find(isAccommodationItem)
  return findFirstAccommodationItem?.occupancy
}

export default getOccupantsFromCheckoutCart
